import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const fieldText = (theme: { palette: { primaryFontFamilyType?: string } }) =>
  `${theme.palette.primaryFontFamilyType}, sans-serif`;

export const StBarOuter = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  padding: '0 24px 24px',
  [theme.breakpoints.down('lg')]: {
    padding: '0 0 24px',
  },
}));

export const StBarCard = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '1202px',
  background: theme.palette.white.main,
  borderRadius: '24px',
  padding: '28px 32px',
  [theme.breakpoints.down('lg')]: {
    padding: '24px 32px',
    borderRadius: '16px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
  },
}));

export const StBarRow = styled('form')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) auto',
  alignItems: 'end',
  columnGap: '16px',
  rowGap: '16px',
  width: '100%',
  // Tablet: condition full width, location + button on the next row
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    rowGap: '24px',
    '& > :first-of-type': {
      gridColumn: '1 / -1',
    },
  },
  // Mobile: all three stacked, button stays hug and right-aligned
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'minmax(0, 1fr)',
    '& > :first-of-type': {
      gridColumn: 'auto',
    },
  },
}));

export const StField = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '6px',
  minWidth: 0,
  width: '100%',
});

export const StLabel = styled(Typography)(({ theme }) => ({
  fontFamily: fieldText(theme),
  fontWeight: 700,
  fontSize: '13px',
  lineHeight: '16px',
  textTransform: 'uppercase',
  color: '#64748B',
}));

export const StInputShell = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  gap: '12px',
  width: '100%',
  height: '51px',
  boxSizing: 'border-box',
  padding: '0 16px',
  background: '#F8FAFC',
  border: '1px solid #CBD5E1',
  borderRadius: '12px',
  position: 'relative',
  '& svg': {
    color: '#94A3B8',
    flexShrink: 0,
  },
  // Autocomplete root is position:relative and was growing past the zip field
  '& .MuiAutocomplete-root, & .MuiFormControl-root, & .MuiTextField-root': {
    position: 'static',
    width: '100%',
    margin: 0,
  },
  '& .MuiOutlinedInput-root, & .MuiAutocomplete-inputRoot': {
    padding: '0 !important',
    minHeight: 0,
    height: 'auto',
    background: 'transparent',
    width: '100%',
  },
  '& .MuiAutocomplete-endAdornment': {
    display: 'none',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  // && beats SearchFormInput's own 13px / neutral11 placeholder sx
  '&& input, && .MuiInputBase-input, && .MuiAutocomplete-input': {
    fontFamily: fieldText(theme),
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '19px',
    padding: '0 !important',
    height: 'auto',
    color: theme.palette.text.primary,
  },
  '&& input::placeholder, && .MuiInputBase-input::placeholder': {
    fontFamily: fieldText(theme),
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '19px',
    color: '#94A3B8',
    opacity: 1,
  },
  '& .MuiFormHelperText-root': {
    position: 'absolute',
    top: 'calc(100% + 4px)',
    left: 0,
    margin: 0,
    lineHeight: '16px',
    fontFamily: fieldText(theme),
  },
}));

export const StSubmitWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexShrink: 0,
  '& .MuiButton-root': {
    height: '54px',
    padding: '16px 48px',
    borderRadius: '48px',
    fontSize: '18px',
    fontWeight: 700,
    textTransform: 'none',
    minWidth: '187px',
  },
  [theme.breakpoints.down('lg')]: {
    '& .MuiButton-root': {
      height: 'auto',
      minWidth: 'unset',
      padding: '14px 32px',
      borderRadius: '40px',
      fontSize: '16px',
    },
  },
}));
